import { application } from "./application"
import { registerControllers } from "stimulus-vite-helpers"
import { registerControllers as registerLayoutControllers } from "@asgerb/apparatus-layout"

const controllers = import.meta.glob("./**/*_controller.js", { eager: true })
registerControllers(application, controllers)
registerLayoutControllers(application)
